var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preview-viewer preview-wps-viewer",attrs:{"id":"wps_frame_div"}})}
var staticRenderFns = []

export { render, staticRenderFns }